const bindEvents = component => {
    // click events on items.
    component.instances.forEach(instance => {
        const {
            classNames: {
                item,
                itemTitle,
                itemOpen,
                itemClosed,
                itemOpenIcon,
                itemClosedIcon,
                iconClosedColor,
                iconOpenColor
            }
        } = component;
        instance.querySelectorAll(`.${item}`).forEach(instanceItem => {
            const iTitle = instanceItem.querySelector(`.${itemTitle}`);
            iTitle.addEventListener('click', ev => {
                if (instanceItem.classList.contains(itemOpen)) {
                    instanceItem.classList.remove(itemOpen);
                    instanceItem.classList.add(itemClosed);
                    if (iTitle) {
                        iTitle.classList.remove(itemOpenIcon, iconOpenColor);
                        iTitle.classList.add(itemClosedIcon, iconClosedColor);
                    }
                } else {
                    instanceItem.classList.remove(itemClosed);
                    instanceItem.classList.add(itemOpen);
                    if (iTitle) {
                        iTitle.classList.remove(
                            itemClosedIcon,
                            iconClosedColor
                        );
                        iTitle.classList.add(itemOpenIcon, iconOpenColor);
                    }
                }
            });
        });
    });
};

const Accordion = {
    classNames: {
        primary: 'accordion',
        item: 'accordion__item',
        itemTitle: 'accordion__item-title',
        itemContent: 'accordion__item-content__container',
        itemOpen: 'accordion__item--open',
        itemClosed: 'accordion__item--closed',
        itemClosedIcon: 'icon-plus',
        itemOpenIcon: 'icon-minus',
        iconOpenColor: 'black',
        iconClosedColor: 'gray',
        subSectionHeader: 'subSectionHeader'
    },
    instances: [],
    init() {
        this.instances = document.querySelectorAll(
            `.${this.classNames.primary}`
        );
        // bindEvents to instances.
        bindEvents(this);
    }
};

export default Accordion;
